(function () {
    'use strict';

    angular
        .module('app.categories')
        .controller('CategoriesListController', categories);

    categories.$inject = ['$scope', '$location', 'CategoriesService', 'NgTableParams', '$timeout'];

    function categories($scope, $location, CategoriesService, NgTableParams, $timeout) {
        /* jshint validthis:true */
        var vm = this;

        function activate() {
            vm.getCategoryList();

            vm.firstLoad = true;
            vm.tableParams = new NgTableParams(
                angular.extend({ page: 1, count: 10 }, $location.search()),
                {
                    getData: function (params) {
                        if (!vm.firstLoad) {
                            $location.search(params.url());
                        }
                        vm.firstLoad = false;
                        var filterData2 = params.filter();
                        var filterData = {};
                        filterData.PageIndex = params.page(),
                            filterData.PageSize = params.count(),
                            filterData.SortProperty = Object.keys(params.sorting())[0],
                            filterData.SortType = params.sorting()[Object.keys(params.sorting())[0]];
                        var keys = Object.keys(filterData2);
                        for (var i = 0; i < keys.length; i++) {
                            filterData[keys[i]] = filterData2[keys[i]];
                        }
                        return CategoriesService.getCategories(filterData).then(function (data) {
                            params.total(data.FilteredCount);
                            return data.Data;
                        });
                    }
                });
        }

        vm.getCategoryList = function () {
            CategoriesService.getCategories({ PageSize: -1 })
                .then(function (data) {
                    vm.categoriesMixed = data.Data;
                    vm.categories = vm.getSubCategoryList(null);
                    $timeout(function () {
                        $(".category-list").treetable({ expandable: true });
                        $(".category-list").treetable('expandAll');
                    }, 0);
                });
        };

        vm.getSubCategoryList = function (TopCategoryId) {
            var categoryList = [];
            var subCategoriesList = vm.categoriesMixed.filter(function (category) {
                return category.TopCategoryId === TopCategoryId;
            });
            for (var i = 0; i < subCategoriesList.length; i++) {
                var item = subCategoriesList[i];
                categoryList.push(item);
                var subItems = vm.getSubCategoryList(item.Id);
                categoryList = categoryList.concat(subItems);
            }
            return categoryList;
        };

        vm.refresh = function () {
            vm.loading = true;
            vm.tableParams.reload();
            vm.loading = false;
        };

        activate();
    }
})();